import { mergeWith, isString, isArray, isBoolean } from 'lodash-es';

export const mergeStreamableComponentsData = components =>
  mergeWith(...components, (destObjValue, srcValue) => {
    if (isString(destObjValue) && isString(srcValue)) {
      return `${destObjValue}${srcValue}`;
    }

    if (isBoolean(destObjValue) && isBoolean(srcValue)) {
      return destObjValue || srcValue;
    }

    if (isArray(destObjValue) && isArray(srcValue)) {
      return [...destObjValue, ...srcValue];
    }

    return undefined;
  });
